const SwitchDashboardsComponents = ({ active, children }) => {
    return children.filter(child => child.props.name == active);
}

export default SwitchDashboardsComponents;